import { uncheckIcon } from "assets/images";

const CheckboxIcon = () => {
  return <img src={uncheckIcon} alt="checkbox" />;
};

export default CheckboxIcon;
